import Fulllayout from '../layouts/fulllayout.jsx';
import Review from '../views/ui-components/review.jsx';
import Detail from '../views/ui-components/detail.jsx'

var indexRoutes = [{ path: '/', name: 'Starter', component: Fulllayout }];

export default indexRoutes;
